import React from 'react'
import { Link } from 'react-router-dom'

const FavoriteTutor = ({ tutor }) => {
  return (
    <div className="relative flex items-center w-full border-[#FFCA84] border-[1px] bg-[#FFF5EE] rounded-[6px] py-[8px] px-[10px]">
      <div className="img_div flex justify-center items-center overflow-hidden">
        <img src={tutor.image} alt={tutor.name} className="w-[36px] h-[36px]" />

        <div className="flex items-start flex-col ml-[12px] flex-1 overflow-hidden">
          <h6 className="max-w-[70%] text-[#F67443] text-base font-semibold mb-[4px] font-Inter text-ellipsis whitespace-nowrap overflow-hidden">
            {tutor.name}
          </h6>

          <div className="flex items-center gap-x-[10px]">
            <div className="flex justify-center items-center">
              <img
                className="w-[16px] h-[16px]"
                src={'/assets/icon/checkbox-multiple-line.svg'}
                alt="Check"
              />
              <span className="text-[#F67443] font-Inter font-medium ml-1 text-xs">
                {tutor.total_bookings || 0}
              </span>
            </div>

            <div className="flex justify-center items-center">
              <img className="w-[16px] h-[16px]" src={'/assets/icon/user-green.svg'} alt="User" />
              <span className="text-[#F67443] font-Inter font-medium ml-1 text-xs">
                {tutor.total_students || 0}
              </span>
            </div>

            <div className="flex justify-center items-center">
              <img className="w-[16px] h-[16px]" src={'/assets/icon/star.svg'} alt="Star" />
              <span className="text-[#F67443] font-Inter font-medium ml-1 text-xs">
                {tutor.overall_rating_average || 0}
              </span>
            </div>

            <div className="flex justify-center items-center">
              <span className="text-[#B733DD] text-xs font-Inter font-bold">ROI</span>
              <span className="text-[#F67443] font-medium ml-1 font-Inter text-xs">
                {tutor.roi}%
              </span>
            </div>

            <div className="flex justify-center items-center">
              <img className="w-[16px] h-[16px]" src={'/assets/icon/euro-coin.svg'} alt="Coin" />
              <span className="text-[#F67443] font-medium ml-1 text-xs font-Inter">
                {tutor.coins}
              </span>
            </div>
          </div>
        </div>
      </div>

      <Link
        to="/student"
        className="absolute z-[1] right-[10px] top-[8px] flex items-center px-[4px] text-center text-[#F79009] hover:text-white hover:bg-[#f79009] h-[22px] font-medium border-[#f79009] border-[1px] rounded-[4px] text-[10px] font-Inter transition-colors duration-200 ease"
      >
        See Profile
      </Link>
    </div>
  )
}

export default FavoriteTutor
